import { render, staticRenderFns } from "./confirmationWindow.vue?vue&type=template&id=dbd36106&scoped=true"
import script from "./confirmationWindow.vue?vue&type=script&lang=js"
export * from "./confirmationWindow.vue?vue&type=script&lang=js"
import style0 from "./confirmationWindow.vue?vue&type=style&index=0&id=dbd36106&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbd36106",
  null
  
)

export default component.exports